import {exibirMensagemErro, HttpVerbo} from "./index";
import axios from "axios";
import {TOKEN} from '../config/constantes/constantes-mantine';


const uuid = () => {
    let d = new Date().getTime();
    let d2 = (performance && performance.now && (performance.now()*1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16;
        if(d > 0){
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
}

function redirecionar() {
    const location = window.location.pathname
    localStorage.clear();
    window.location.assign("/?url="+location);

}

function filtroErro(e) {
    switch (e.status) {
        case 401: {
            exibirMensagemErro('Usuário não autenticado');
            if (!e.url.endsWith('/login')) setTimeout(redirecionar, 3000);
            return;
        }
        case 403: {
            exibirMensagemErro('Você não possui permissão');
            return;
        }
        case 404: {
            exibirMensagemErro('Endereço não encontrado');
            return;
        }
        case 400: {
            Promise.resolve(e.json()).then(json => exibirMensagemErro(json.message))
            return;
        }
        case 500: {
            Promise.resolve(e.json()).then(json => exibirMensagemErro(json.message))
            return;
        }
        default: {
            return e;
        }
    }
}

export const xfetch = (endpoint, dados, verbo = HttpVerbo.GET, options) => {
    const servidor = process.env.REACT_APP_BACKEND
    let myHeaders = new Headers();
    let idTransacao = uuid();
    myHeaders.append("Content-Type", options === undefined ? "application/json" : options);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("idTransacao", idTransacao);
    if (localStorage.getItem(TOKEN) && !endpoint.startsWith('/publica')) {
        myHeaders.append("Authorization", 'Bearer ' + localStorage.getItem(TOKEN));
    }

    const myInit = { method: verbo,
        headers: myHeaders,
        mode: 'cors',
        cache: 'default' };

    if (verbo === HttpVerbo.POST || verbo === HttpVerbo.PUT || verbo === HttpVerbo.DELETE) {
        return fetch(servidor+endpoint, {
            headers: myHeaders,
            method: verbo,
            body: JSON.stringify(dados)
        }).then(filtroErro);
    } else {
        return fetch(servidor+endpoint, myInit).then(filtroErro);
    }
}

export const upload = (endpoint, dados) => {
    const servidor = process.env.REACT_APP_BACKEND
    const idTransacao = uuid();
    console.log(endpoint)
    return axios.post(servidor + endpoint, dados, {
        headers: {
            'idTransacao': idTransacao.toString(),
            'Authorization': 'Bearer ' + localStorage.getItem(TOKEN),
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const downloadArquivo = (endpoint, nome) => {
    const servidor = process.env.REACT_APP_BACKEND
    const idTransacao = uuid();

    axios.get(servidor + endpoint, {
        headers: {
            'idTransacao': idTransacao.toString(),
            'Authorization': 'Bearer ' + localStorage.getItem(TOKEN),
        },
        responseType: 'blob'
    })
      .then((response) => {
          const temp = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = temp;
          link.setAttribute('download', nome); //or any other extension
          document.body.appendChild(link);
          link.click();
      })
      .catch(err => exibirMensagemErro('Erro ao fazer download -' +err))
}
